import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { ScrollText, RefreshCw, Loader2 } from 'lucide-react';

function formatDate(d) {
  if (!d) return '—';
  try { return new Date(d).toLocaleString(); } catch { return d; }
}

export default function ZohoFormLogs({ logs, loading, onRefresh }) {
  if (loading) {
    return <div className="flex justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={onRefresh} data-testid="refresh-logs-btn">
          <RefreshCw className="h-4 w-4 mr-1" />Refresh
        </Button>
      </div>

      <Card>
        <CardContent className="p-0">
          {logs.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground" data-testid="empty-logs">
              <ScrollText className="h-10 w-10 mx-auto mb-2 opacity-20" />
              <p className="font-medium">No webhook logs</p>
              <p className="text-sm mt-1">Logs will appear here when the webhook URL receives requests</p>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Time</TableHead>
                  <TableHead className="text-center">HTTP Status</TableHead>
                  <TableHead className="text-right">Processing (ms)</TableHead>
                  <TableHead>Error</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {logs.map(l => (
                  <TableRow key={l.id} data-testid={`log-row-${l.id}`}>
                    <TableCell className="text-sm">{formatDate(l.timestamp)}</TableCell>
                    <TableCell className="text-center">
                      <Badge variant={l.http_status_returned === 200 ? 'default' : 'destructive'}>
                        {l.http_status_returned}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right font-mono text-sm">{l.processing_time_ms || '—'}</TableCell>
                    <TableCell className="max-w-[250px] truncate text-sm text-muted-foreground">
                      {l.error_details || '—'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
